import React from 'react';
import Row from '../components/Row'

const ZonesImport = ({handleSelectFile, navigator, currentZones, searchTerm, setSearchTerm}) => {
    return (
        <div>
            <ol className="breadcrumb">
                <li>
                    <a onClick={ navigator.requestScenarioManagement }>
                        Scenario Management
                    </a>
                </li>
                <li className="active">
                    Zones Import
                </li>
            </ol>

            <div className="edit-scenario-form zones-import">
                <h3>Import CSV</h3>
                <br />
                <p>Import a CSV of zones information for this Scenario.</p>
                <p>Maximum file size is 25MB files must contain only two columns <b className="bold">zone_id</b> and <b className="bold">zone_name</b></p>
                <p><strong>Note:</strong> Uploading a new file will replace the current zones.</p>
                <div>
                    <h4>Header (zone_id,zone_name) for csv is mandatory. Below is a sample CSV:</h4>
                    <pre className="user-select-all">
                        {`
                          zone_id,zone_name
                          123,zone1
                          456,zone2
                          789,zone3
                        `}
                    </pre>
                </div>
                <br />
                <br />
                <label className="btn btn-primary" id="zones-upload">
                    Select CSV File
                    <input 
                        type="file"
                        accept="text/csv" 
                        className="form-control inputFile" 
                        id="zones-upload" 
                        onChange={handleSelectFile}
                    /> 
                </label>
            </div>

            { currentZones.length ? (
                <div className="edit-scenario-form">
                    <div className="zones-import__table-header">
                        <h3>Current Zones</h3>
                        <input 
                            type="search" 
                            value={searchTerm} 
                            onChange={setSearchTerm} 
                            placeholder="Search..."
                            className="form-control"
                        />
                    </div> 
                <table className="table">
                    <thead>
                        <tr>
                            <th><div className={`text-center table-header col-sm-4`}>Id</div></th>
                            <th><div className={`text-center table-header col-sm-8`}>Name</div></th>
                        </tr>
                    </thead>
                    <tbody>
                        { currentZones
                            .filter(zone => `${zone.zoneId} ${zone.zoneName}`
                                .toLowerCase()
                                .indexOf(searchTerm.toLowerCase()) >= 0)
                            .map(zone => <Row data={zone}/>)
                        }
                    </tbody>
                </table>
             </div>
            ) : (
                <div className="edit-scenario-form flex-center">
                    <h4>No Zones in this scenario yet.</h4>
                </div>
            )}
        </div>
    );
}


export default ZonesImport;
